const GLOBAL_CONST = {
  PICKUP_STATUS: {
    NOT_DISMISSED: 5,
    ANNOUNCED: 3,
    DISMISSED: 6,
    ABSENT: 7,
  },
  SCREEN_NAMES: {
    LOGIN: "Login",
    FORGOT_PASSWORD: "Forgot_Password",
    DASHBOARD: "Dashboard",
    PICKUP: "Pickup",
    REGISTRATION_NAME: "Registration_Name",
    REGISTRATION_EMAIL: "Registration_Email",
    REGISTRATION_CONFIRM_EMAIL: "Registration_Confirm_Email",
    REGISTRATION_PHONE: "Registration_Phone",
    REGISTRATION_CONFIRM_PHONE: "Registration_Confirm_Phone",
    REGISTRATION_PASSWORD: "Registration_Password",
    REGISTRATION_SUCCESS: "Registration_Success",
    REGISTRATION_CHOOSE_ROLE: "Registration_Choose_Role",
    REGISTRATION_SUBMIT_FEEDBACK: "Registration_Submit_Feedback",
    SCHOOL_DETAILS: "School_Details",
    SCHOOL_DISMISSAL_TIME: "School_Dismissal_Time",
    CHECKIN_FOR: "CheckIn_For",
    CHECKIN_QUESTIONS: "CheckIn_Questions",
    NOTIFICATIONS_SCREEN: "Notifications_Screen",
    MANAGE_CHILDREN_TAB: "Manage_Children_Tab",
    CHILD_DETAILS: "Child_Details",
    DEFAULT_PICKUP_MODE: "Default_Pickup_Mode",
    MARK_ABSENT: "Mark_Absent",
    SET_CHILD_PHOTO: "Set_Child_Photo",
    SELECT_WHEN: "Select_When",
    DISMISSAL_HOW: "Dismissal_How",
    CONTACT_SCREEN: "Contact_Screen",
    CHANGE_PASSWORD: "Change_Password",
    SETTING_NOTIFICATION: "Setting_Notification",
    ADD_CONTACT: "Add_Contact",
    FUTURE_DELEGATIONS: "Future_Delegations",
    CONTACT_SUPPORT: "Contact_Support",
    FAQ: "Faq",
    TERM_CONDITIONS: "Term_Conditions",
    PROFILE_SCREEN: "Profile_Screen",
    DISMISSAL_HISTORY: "Dismissal_history",
  },
  DAYS_EN: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  DAYS_FULL_EN: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  DAYS_ES: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  DAYS_FULL_ES: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  
  VERSION: "2.1.14",
};

export default GLOBAL_CONST;
